import * as React from 'react';

import {Illustration} from '../illustrations/illustration';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

import styles from './chat-preview.module.css';

type Props = {
    offlineMessage: string;
};

export function OfflineContent(props: Props) {
    return (
        <>
            <StackLegacy spacing={16}>
                <span className='word-break'>{props.offlineMessage}</span>
                <div className={styles['offline-form-container']}>
                    <Illustration src='form-fields' width='100%' height='100%' />
                    <Body size='small' isBold={true}>
                        Your Nutshell form goes here
                    </Body>
                    <Body size='mini'>Customize your form before attaching it</Body>
                </div>
            </StackLegacy>
        </>
    );
}
